import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactSection.css';
import mexicoMapUrl from '../assets/mx.svg'; 

import { FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

const ContactSection = () => {
  const sectionRef = useRef();
  const [svgContent, setSvgContent] = useState(''); 

  useEffect(() => {
    fetch(mexicoMapUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(svgText => {
        setSvgContent(svgText);
      })
      .catch(error => console.error("Error loading SVG:", error));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const serviceID = 'service_5w1hnax';
    const templateID = 'template_18md0zg';
    const publicKey = 'gY58arn-yStwBvYVl';
    
    const data = new FormData(e.target);

    var templateParams = {
      title: "Nuevo mensaje de contacto",
      name: data.get('name'),
      email: data.get('email'),
      message: data.get('message'),
      service: data.get('service'),
    }
    
    
    emailjs.send(serviceID, templateID, templateParams, publicKey)
    .then((result) => {
      alert('¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.');
      e.target.reset();
    }, (error) => {
      alert('Ocurrió un error al enviar el mensaje. Por favor, inténtalo de nuevo.');
    });
    e.target.reset();
  };

  const handleStateClick = (stateId) => {
    console.log(`Has hecho clic en el estado: ${stateId}`);

  };

  return (
    <section id="contacto" className="contact-section" ref={sectionRef}>
      <div className="container">
        <h2>Contáctanos</h2>
        <div className="contact-info">
          <p>56 1890 8857 <span className="separator">|</span></p> 
          <p>55 2144 7415 <span className="separator">|</span></p>
          <p>@fortec_mx <span className="separator">|</span></p>
          <p>fortecmx.com</p>
        </div>

        <div className="contact-grid">
          <div className="map-container">
            {svgContent ? (
              <div dangerouslySetInnerHTML={{ __html: svgContent }} />
            ) : (
              <p>Cargando mapa...</p>
            )}
          </div>
          <div className="contact-form-container">
            <h3>También nos puedes mandar un mensaje</h3>
            <form ref={sectionRef} onSubmit={handleSubmit} className="contact-form">
              <input type="text" name="name" placeholder="Nombre" required />
              <input type="email" name="email" placeholder="Correo electrónico" required />
              <div className="select-wrapper">
                <select name="service" defaultValue="" required>
                  <option value="" disabled>Servicios</option>
                  <option value="Desarrollo de Software">Desarrollo de Software</option>
                  <option value="Desarrollo de Apps">Desarrollo de Apps</option>
                  <option value="Diseño de Marca">Diseño de Marca</option>
                  <option value="Otro">Otro</option>
                </select>
                <span className="select-arrow"></span>
              </div>
              <textarea name="message" placeholder="Mensaje" rows="5" required></textarea>
              <button type="submit">Enviar</button>
            </form>
          </div>
        </div>
      </div>
      <div className="social-media-footer">
        <a href="https://instagram.com/fortec_mx" target="_blank" rel="noopener noreferrer" className="icon-link">
          <FaInstagram />
        </a>
        <a href="https://linkedin.com/company/fortec_mx" target="_blank" rel="noopener noreferrer" className="icon-link">
          <FaLinkedinIn />
        </a>
        <a href="https://twitter.com/fortec_mx" target="_blank" rel="noopener noreferrer" className="icon-link">
          <FaTwitter />
        </a>
      </div>
    </section>
  );
};

export default ContactSection;